import React, { useRef, useState } from 'react';
import { isNil } from 'lodash';
import Globalizer from '../../../globalizer';
import translateService from '../../../common/translateService';
import { reportFeedbackAbuse } from '../../../services/feedbacks/feedbacksService';
import {
    toggleNextElementVisibility,
    handleAbuseTypeChange,
} from '../../../services/product/productInteraction';
import ReviewStars from '../reviews/ReviewStars.jsx';

const Feedback = ({ feedback, isUserAuthenticated }) => {
    Globalizer.init();

    const reportAbuseFormRef = useRef(null);
    const [abuseType, setAbuseType] = useState('');

    const handleRadioButtonClick = (e) => {
        handleAbuseTypeChange(e, reportAbuseFormRef);
        const type = e.currentTarget.value;
        setAbuseType(type);
    };

    async function handleSendReportAbuse() {
        const result = await reportFeedbackAbuse(feedback.id, abuseType);

        if (result.isSuccess) {
            reportAbuseFormRef.current.classList.remove('open');
        }
    }

    return (
        <div className='feedback'>
            <div className='feedback-content'>
                <h3 className='feedback-title'>{feedback.title}</h3>
                <div className='feedback-heading'>
                    <div className='feedback-rating'>
                        <p>
                            <span>
                                {translateService.get(
                                    `form.labels.useExperienceVote`
                                )}
                            </span>{' '}
                            <ReviewStars
                                average={feedback.useExperienceVote}
                                maxRating={5}
                            />
                        </p>
                        <p>
                            <span>
                                {translateService.get(
                                    `form.labels.serviceQualityVote`
                                )}
                            </span>{' '}
                            <ReviewStars
                                average={feedback.serviceQualityVote}
                                maxRating={5}
                            />
                        </p>
                    </div>
                    <p>
                        {`${
                            feedback.user.nickname
                        } | ${Globalizer.formatDateLong(
                            feedback.creationDate
                        )}`}
                    </p>
                </div>
                <p dangerouslySetInnerHTML={{ __html: feedback.description }} />
                {!isNil(feedback.answer) && (
                    <div className='feedback-answer'>
                        <h4 className='feedback-answer-title'>
                            {translateService.get(`feedbacks.answerFromStaff`)}
                        </h4>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: feedback.answer.description,
                            }}
                        />
                        <h4 className='feedback-answer-author'>
                            {feedback.answer.userNickname}
                        </h4>
                    </div>
                )}
            </div>
            <div className='feedback-footer'>
                <div className='feedback-form'>
                    {isUserAuthenticated && (
                        <div className='feedback-reportAbuse'>
                            <p
                                className='link'
                                onClick={toggleNextElementVisibility}>
                                {translateService.get(`feedbacks.reportAbuse`)}
                            </p>
                            <div
                                className='feedback-reportAbuse-form'
                                ref={reportAbuseFormRef}>
                                <p>
                                    {translateService.get(
                                        `feedbacks.abuseKind`
                                    )}
                                </p>
                                <label htmlFor='vulgar'>
                                    <input
                                        onMouseUp={handleRadioButtonClick}
                                        type='radio'
                                        name='vulgar'
                                        value='Vulgar'
                                    />
                                    {translateService.get(
                                        `productDetail.vulgar`
                                    )}
                                </label>
                                <label htmlFor='spam'>
                                    <input
                                        onMouseUp={handleRadioButtonClick}
                                        type='radio'
                                        name='spam'
                                        value='Spam'
                                    />
                                    {translateService.get(`productDetail.spam`)}
                                </label>
                                <label htmlFor='useless'>
                                    <input
                                        onMouseUp={handleRadioButtonClick}
                                        type='radio'
                                        name='useless'
                                        value='Useless'
                                    />
                                    {translateService.get(
                                        `productDetail.useless`
                                    )}
                                </label>
                                <a
                                    className='link'
                                    onClick={handleSendReportAbuse}>
                                    {translateService.get(`productDetail.send`)}
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Feedback;
